'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { forwardRef, useMemo, } from 'react';
import styles from './separator.module.css';
export const Separator = forwardRef(({ className, vPadding, hPadding, dimmed = 2, vertical = false, style, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => ({
        '--v-padding': vPadding ? tkns.space[vPadding] : 0,
        '--h-padding': hPadding ? tkns.space[hPadding] : 0,
        '--color': `var(--dimmed-${dimmed})`,
    }), [vPadding, hPadding, dimmed]);
    return (_jsx("hr", { ref: forwardedRef, className: clsx(styles.Separator, className), "data-separator-vertical": vertical, style: { ...dynamicStyle, ...style }, ...otherProps }));
});
